import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { AuthGuard } from '../../abacus/guards/auth.guard'
import { PermissionGuard } from '../../abacus/guards/permission.guard'

import { IntergovernmentalOrganisationListComponent } from './intergovernmental-organisation-list/intergovernmental-organisation-list.component'

export const intergovernmentalOrganisationRoutes: Route[] = [
  {
    path: 'intergovernmental-organisations',
    component: IntergovernmentalOrganisationListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browsePolicyInitiativeTaxonomies'
    }
  },
  {
    path: 'intergovernmental-organisations/:id/edit',
    redirectTo: 'intergovernmental-organisations/:id',
    pathMatch: 'full'
  },
  {
    path: 'intergovernmental-organisations/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'IntergovernmentalOrganisation',
        nameSingular:
          'Membership in intergovernmental or supranational organisation',
        namePlural: 'Intergovernmental Organisations',
        path: 'intergovernmental-organisations',
        slug: 'intergovernmental-organisations',
        title: 'Intergovernmental Organisations',
        propertiesToExcludeFromDisplay: [
          'id',
          'propertiesInArray',
          'order',
          'deletedAt',
          'countries',
          'countryIds'
        ]
      }),
      permission: 'readPolicyInitiativeTaxonomies'
    }
  }
]
